// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 8/12/2024 11:20:07 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { SecurityRoleTypeEnum } from '../schema/Schema';
import { LocationTypeEnum } from '../schema/Schema';
import { PersonTypeEnum } from '../schema/Schema';
import { CultureTypeEnum } from '../schema/Schema';

export enum GetClientCompanyRequestEnum {}

export enum GetUserListSortEnum {
  name = 0,
  employmentType = 1,
  email = 2,
  lastLoggedIn = 3,
  department = 4,
  securityRoleType = 5,
}

export enum GetRoleListEnum {}

export enum GetUserEnum {
  invalidUserId = 0,
}

export enum GetUserListEnum {
  takeLessThen1 = 0,
  takeMoreThen100 = 1,
  skipLessThan0 = 2,
  invalidFilters = 3,
  invalidSecurityRoleId = 4,
}

export enum GetSecurityRoleEnum {}

export enum MaintainPersonSecurityRoleEnum {}

export enum PersistUserEnum {
  userExistsWithEmail = 0,
}

export enum ResetToDefaultPermissionEnum {
  invalidSecurityRoleId = 0,
  invalidSecurityRoleType = 1,
}

export enum PersistSecurityRoleEnum {
  invalidSecurityRoleId = 0,
}

export enum PersistUserPermissionEnum {
  invalidSecurityRoleId = 0,
  invalidUserId = 1,
}

export enum SetupPayrollFirmEnum {}

export interface GetClientCompanyRequestInterface {
  clientId: number;
  filterByEmail: boolean;
  email: string;
  filterByName: boolean;
  name: string;
  partnerId: number;
}

export interface GetClientCompanyResponseInterface {
  clientCompany: ClientCompanyInterface;
  validationResults: ValidationResultsInterface;
}

export interface ClientCompanyInterface {
  id: number;
  companyName: string;
  contactEmail: string;
  firstName: string;
  lastName: string;
  country: string;
  clientSetupAllowed: boolean;
  companyCode: string;
  securityRoleType: SecurityRoleTypeEnum;
  isOnboardingCompleted: boolean;
  logoId?: number;
  invitationId: number;
  canEditContactEmail?: boolean;
  address: AddressInterface;
  adminList: Array<AdminInterface>;
}

export interface AddressInterface {
  id: number;
  name: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  postal: string;
  locationType: LocationTypeEnum;
  stateId?: number;
  countryId: number;
}

export interface GetRoleListRequestInterface {
  includeUserCount: boolean;
  partnerId: number;
}

export interface GetRoleListResponseInterface {
  securityRoleList: Array<SecurityRoleInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SecurityRoleInterface {
  id: number;
  name: string;
  description: string;
  userCount: number;
  securityRoleType: SecurityRoleTypeEnum;
  companyId: number;
  hasCustomization: boolean;
  permissionCategoryList: Array<PermissionCategoryInterface>;
  userList: Array<UserInterface>;
}

export interface PermissionCategoryInterface {
  id: number;
  name: string;
  description?: string; //TODO NA: do fix  with description?: -> description:
  permissionSubCategoryList: Array<PermissionSubCategoryInterface>;
}

export interface PermissionSubCategoryInterface {
  id: number;
  name: string;
  description: string; //TODO NA: do fix  with description?: -> description:
  parentSubCategoryId?: number;
  permissionList: Array<PermissionInterface>;
}

export interface PermissionInterface {
  id: number;
  name: string;
  description?: string;
  isRead: boolean;
  isReadWrite: boolean;
  isSelected: boolean;
  isSubmit: boolean;
  isApprove: boolean;
}

export interface UserInterface {
  id: number;
  email: string;
  lastLogin?: string;
  firstName: string;
  lastName: string;
  isEmployee: boolean;
  isDisabled: boolean;
  isEditable: boolean;
  personType: PersonTypeEnum;
  securityRoleTypeList: Array<SecurityRoleTypeEnum>;
  phoneNumber: string;
  cultureType: CultureTypeEnum;
  companyId: number;
  personId: number;
  twoFactorEnabled: boolean;
  countryType: string;
  passwordAssignmentDate: string;
  profileDocumentId?: number;
  isFirstTimeLogin: boolean;
  hasChangedPassword: boolean;
  clientCount: number;
  isInvited: boolean;
  invitedDate?: string;
  departmentList: Array<DepartmentInterface>;
  stateList: Array<StateInterface>;
  clientList: Array<ClientInterface>;
}

export interface DepartmentInterface {
  id: number;
  name: string;
}

export interface StateInterface {
  id: number;
  name: string;
  personSummary: PersonSummaryInterface;
}

export interface PersonSummaryInterface {
  userId?: number;
  email: string;
  lastLogin?: string;
  firstName: string;
  lastName: string;
  personType: PersonTypeEnum;
  phoneNumber: string;
  companyId: number;
  personId: number;
  countryType: string;
  stateList: Array<StateInterface>;
}

export interface GetUserListRequestInterface {
  securityRoleId: number;
  take: number;
  skip: number;
  companyId: number;
  securityRoleTypeIdList: Array<number>;
  includeRole: boolean;
  includeEditAccess: boolean;
  filterByEmail: boolean;
  emailContains: string;
  includeDisabled: boolean;
  filterByName: boolean;
  nameContains: string;
  sortColumnType: GetUserListSortEnum;
  sortAscending: boolean;
  includeClientCount: boolean;
  clientCompanyId?: number;
}

export interface GetUserListResponseInterface {
  totalCount: number;
  userList: Array<UserInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetUserRequestInterface {
  userId: number;
  includeSecurityRoleList: boolean;
  includePermission: boolean;
  includeClientList: boolean;
  partnerId: number;
  includeClientAcceptedInviteOnly: boolean;
}

export interface GetUserResponseInterface {
  securityRoleList: Array<SecurityRoleInterface>;
  user: UserInterface;
  validationResults: ValidationResultsInterface;
}

export interface GetSecurityRoleRequestInterface {
  securityRoleId: number;
  includeUserList: boolean;
  includePermissionList: boolean;
  securityRoleType: SecurityRoleTypeEnum;
  companyId: number;
}

export interface GetSecurityRoleResponseInterface {
  securityRole: SecurityRoleInterface;
  validationResults: ValidationResultsInterface;
}

export interface MaintainPersonSecurityRoleRequestInterface {
  userId: number;
  securityRoleId: number;
  securityRoleType: SecurityRoleTypeEnum;
  assign: boolean;
  unassign: boolean;
  stateIdList?: Array<number>;
  partnerId: number;
}

export interface MaintainPersonSecurityRoleResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistUserRequestInterface {
  personId: number;
  emailAddress: string;
  firstName: string;
  lastName: string;
  securityRoleType: SecurityRoleTypeEnum;
  stateIdList?: Array<number>;
  partnerId: number;
}

export interface PersistUserResponseInterface {
  userId: number;
  validationResults: ValidationResultsInterface;
}

export interface PersistSecurityRoleRequestInterface {
  securityRoleId: number;
  keepCustomization: boolean;
  companyId: number;
  permissionCategoryList: Array<PermissionCategoryInterface>;
}

export interface PersistSecurityRoleResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ResetToDefaultPermissionRequestInterface {
  securityRoleId: number;
  securityRoleType: SecurityRoleTypeEnum;
  companyId: number;
}

export interface ResetToDefaultPermissionResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistUserPermissionRequestInterface {
  userId: number;
  securityRoleType: SecurityRoleTypeEnum;
  companyId: number;
  permissionCategoryList: Array<PermissionCategoryInterface>;
}

export interface PersistUserPermissionResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ClientInterface {
  id: number;
  name: string;
}

export interface MaintainUserRequestInterface {
  userId: number;
  enable: boolean;
  disable: boolean;
  partnerId: number;
}

export interface MaintainUserResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface SetUpPayrollFirmRequestInterface {
  partnerId: number;
}

export interface SetUpPayrollFirmResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface AdminInterface {
  userId: number;
  personId: number;
  firstName: string;
  lastName: string;
}

export interface ChangeAccountOwnerEmailRequestInterface {
  partnerId: number;
  newEmail: string;
  oldEmail: string;
}

export interface ChangeAccountOwnerEmailResponseInterface {
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class PartnerAccessService {
  getClientCompany(request: GetClientCompanyRequestInterface): Promise<GetClientCompanyResponseInterface> {
    return Post('/AppCorePartnerAccess/getClientCompany', request);
  }

  getRoleList(request: GetRoleListRequestInterface): Promise<GetRoleListResponseInterface> {
    return Post('/AppCorePartnerAccess/getRoleList', request);
  }

  getUserList(request: GetUserListRequestInterface): Promise<GetUserListResponseInterface> {
    return Post('/AppCorePartnerAccess/getUserList', request);
  }

  getUser(request: GetUserRequestInterface): Promise<GetUserResponseInterface> {
    return Post('/AppCorePartnerAccess/getUser', request);
  }

  getSecurityRole(request: GetSecurityRoleRequestInterface): Promise<GetSecurityRoleResponseInterface> {
    return Post('/AppCorePartnerAccess/getSecurityRole', request);
  }

  maintainPersonSecurityRole(
    request: MaintainPersonSecurityRoleRequestInterface
  ): Promise<MaintainPersonSecurityRoleResponseInterface> {
    return Post('/AppCorePartnerAccess/maintainPersonSecurityRole', request);
  }

  persistUser(request: PersistUserRequestInterface): Promise<PersistUserResponseInterface> {
    return Post('/AppCorePartnerAccess/persistUser', request);
  }

  persistSecurityRole(request: PersistSecurityRoleRequestInterface): Promise<PersistSecurityRoleResponseInterface> {
    return Post('/AppCorePartnerAccess/persistSecurityRole', request);
  }

  resetToDefaultPermission(
    request: ResetToDefaultPermissionRequestInterface
  ): Promise<ResetToDefaultPermissionResponseInterface> {
    return Post('/AppCorePartnerAccess/resetToDefaultPermission', request);
  }

  persistUserPermission(
    request: PersistUserPermissionRequestInterface
  ): Promise<PersistUserPermissionResponseInterface> {
    return Post('/AppCorePartnerAccess/persistUserPermission', request);
  }

  maintainUser(request: MaintainUserRequestInterface): Promise<MaintainUserResponseInterface> {
    return Post('/AppCorePartnerAccess/maintainUser', request);
  }

  setUpPayrollFirm(request: SetUpPayrollFirmRequestInterface): Promise<SetUpPayrollFirmResponseInterface> {
    return Post('/AppCorePartnerAccess/setUpPayrollFirm', request);
  }

  changeAccountOwnerEmail(
    request: ChangeAccountOwnerEmailRequestInterface
  ): Promise<ChangeAccountOwnerEmailResponseInterface> {
    return Post('/AppCorePartnerAccess/changeAccountOwnerEmail', request);
  }
}

export default new PartnerAccessService();
